export const COOKIES = {
  REMEMBER_ME: "_rememeber_me",
}

export enum CheckoutActions {
  USER_DATA_PENDING = "CHECKOUT.ACTIONS.USER_DATA.PENDING",
  USER_DATA_SUCCESS = "CHECKOUT.ACTIONS.USER_DATA.SUCCESS",
  USER_DATA_FAILURE = "CHECKOUT.ACTIONS.USER_DATA.FAILURE",
  AUTH_PENDING = "CHECKOUT.ACTIONS.AUTH.PENDING",
  AUTH_SUCCESS = "CHECKOUT.ACTIONS.AUTH.SUCCESS",
  EXTERNAL_AUTH_SUCCESS = "CHECKOUT.ACTIONS.AUTH.EXTERNAL_AUTH_SUCCESS",
  EXTERNAL_AUTH_DONE = "CHECKOUT.ACTIONS.AUTH.EXTERNAL_AUTH_DONE",
  AUTH_FAILURE = "CHECKOUT.ACTIONS.AUTH.FAILURE",
  AUTH_LOGIN_RESET = "CHECKOUT.ACTIONS.AUTH.LOGIN_RESET",
  AUTH_LOGIN_SKIP = "CHECKOUT.ACTIONS.AUTH.LOGIN_SKIP",
  AUTH_UNKNOWN_LOGIN = "CHECKOUT.ACTIONS.AUTH.UNKNOWN_LOGIN",

  USER_REGISTER_SUCCESS = "CHECKOUT.ACTIONS.USER_REGISTER.SUCCESS",
  USER_UPDATE_SUCCESS = "CHECKOUT.ACTIONS.USER_UPDATE.SUCCESS",
  BASKET_PENDING = "CHECKOUT.ACTIONS.BASKET.PENDING",
  BASKET_SUCCESS = "CHECKOUT.ACTIONS.BASKET.SUCCESS",
  BASKET_FAILURE = "CHECKOUT.ACTIONS.BASKET.FAILURE",
  RESET = "ACTIONS.CHECKOUT.RESET",
  USER_PENDING = "USER.ACTIONS.USER.PENDING",
  USER_SUCCESS = "USER.ACTIONS.USER.SUCCESS",
  USER_FAILURE = "USER.ACTIONS.USER.FAILURE",
  BASKET_PARAMS_GET_PENDING = "CHECKOUT.ACTIONS.BASKET_PARAMS.GET.PENDING",
  BASKET_PARAMS_GET_SUCCESS = "CHECKOUT.ACTIONS.BASKET_PARAMS.GET.SUCCESS",
  BASKET_PARAMS_GET_FAILURE = "CHECKOUT.ACTIONS.BASKET_PARAMS.GET.FAILURE",
  BASKET_PARAMS_SAVE_PENDING = "CHECKOUT.ACTIONS.BASKET_PARAMS.SAVE.PENDING",
  BASKET_PARAMS_SAVE_SUCCESS = "CHECKOUT.ACTIONS.BASKET_PARAMS.SAVE.SUCCESS",
  BASKET_PARAMS_SAVE_FAILURE = "CHECKOUT.ACTIONS.BASKET_PARAMS.SAVE.FAILURE",
  CHECKOUT_RESET = "CHECKOUT.ACTIONS.CHECKOUT.RESET",
  PERSON_DATA_SAVE = "CHECKOUT.PERSON_DATA.SAVE",
  COMPANY_DATA_SAVE = "CHECKOUT.COMPANY_DATA.SAVE",
  ADDRESS_CONFIRMATION_CLOSE = "CHECKOUT.ADDRESS_CONFIRMATION_CLOSE",
  ADDRESS_CONFIRMATION_OPEN = "CHECKOUT.ADDRESS_CONFIRMATION_OPEN",
  USER_EDIT_DATA_MODAL_OPEN = "CHECKOUT.ACTIONS.USER_EDIT_DATA_MODAL_OPEN",
  USER_EDIT_DATA_MODAL_CLOSE = "CHECKOUT.ACTIONS.USER_EDIT_DATA_MODAL_CLOSE",
}

export enum CheckoutConflictTypes {
  ADDRESS_CONFIRMATION_NEEDED = "address_confirmation_needed",
  ADDRESS_CONFIRMATION_NEEDED_TYPE = "https://home.pl/onestore/address-confirmation-needed",
}
